import { loadView } from '@/helper/utils'
import { mainLayout } from '@/components/layouts/Main'

export default {
  path: '/horoscope',
  component: mainLayout(loadView('horoscope/Horoscope')),
  children: [
    {
      path: '',
      name: 'HoroscopeTop',
      component: loadView('horoscope/HoroscopeTop'),
      meta: { requiresAuth: true }
    },
    {
      path: 'result',
      name: 'HoroscopeResult',
      component: loadView('horoscope/HoroscopeResult'),
      meta: { requiresAuth: true }
    }
  ]
}
